import {englishType} from 'types'

export const lesson23: englishType[] = [
  {
    id: 1,
    word: "additional",
    meaning: ["추가적인", "덧붙이는"]
  }, {
    id: 2,
    word: "alternative",
    meaning: ["대안", "대책", "대안의", "대책의"]
  }, {
    id: 3,
    word: "benefit",
    meaning: ["이익", "혜택"]
  }, {
    id: 4,
    word: "biodegradable",
    meaning: ["생분해성의", "자연분해성의", "친환경적으로 분해 가능한"]
  }, {
    id: 5,
    word: "consumption",
    meaning: ["소비"]
  }, {
    id: 6,
    word: "coworker",
    meaning: ["동료"]
  }, {
    id: 7,
    word: "edible",
    meaning: ["먹을 수 있는", "식용 가능한", "식용의"]
  }, {
    id: 8,
    word: "emission",
    meaning: ["배출", "방출", "배기가스", "배출물"]
  }, {
    id: 9,
    word: "enormous",
    meaning: ["막대한", "거대한"]
  }, {
    id: 10,
    word: "estimate",
    meaning: ["추정", "추산", "추정하다", "추산하다"]
  }, {
    id: 11,
    word: "generate",
    meaning: ["발생시키다", "만들어내다"]
  }, {
    id: 12,
    word: "landfill",
    meaning: ["쓰래기 매립지", "쓰래기 매립장"]
  }, {
    id: 13,
    word: "lightweight",
    meaning: ["가벼운"]
  }, {
    id: 14,
    word: "manufacture",
    meaning: ["제조", "제조하다", "제품", "생산하다"]
  }, {
    id: 15,
    word: "mixture",
    meaning: ["혼합", "혼합물", "혼합제"]
  }, {
    id: 16,
    word: "mold",
    meaning: ["거푸집", "형틀", "틀", "주조하다"]
  }, {
    id: 17,
    word: "replace",
    meaning: ["대신하다", "바꿔놓다", "바꾸다", "다시 놓다"]
  }, {
    id: 18,
    word: "reusable",
    meaning: ["재사용 가능한", "재사용할 수 있는"]
  }, {
    id: 19,
    word: "survey",
    meaning: ["조사", "조망", "조사하다", "조망하다"]
  }, {
    id: 20,
    word: "threaten",
    meaning: ["협박하다", "위협하다", "조짐을 보이다"]
  }, {
    id: 21,
    word: "annoying",
    meaning: ["귀찮게 하는", "짜증나게 하는", "성가시게 하는"]
  }, {
    id: 22,
    word: "chemical",
    meaning: ["화학의", "화학 물질", "화학적인"]
  }, {
    id: 23,
    word: "principal",
    meaning: ["학장"]
  }, {
    id: 24,
    word: "seaweed",
    meaning: ["해조", "해초"]
  }, {
    id: 25,
    word: "global",
    meaning: ["세계적인", "지구의", "전반적인"]
  }, {
    id: 26,
    word: "plastic",
    meaning: ["플라스틱"]
  }, {
    id: 27,
    word: "despite",
    meaning: ["~에도 불구하고"]
  }, {
    id: 28,
    word: "pollute",
    meaning: ["오염시키다"]
  }, {
    id: 29,
    word: "severely",
    meaning: ["심각한", "극심한", "가혹한", "엄한", "엄격한"]
  }, {
    id: 30,
    word: "pollution",
    meaning: ["오염", "오염 물질"]
  }, {
    id: 31,
    word: "result in",
    meaning: ["그 결과 ~가 되다", "~를 낳다", "~결과가 나오다", "~라는 결과를 얻다"]
  }, {
    id: 32,
    word: "unfortunately",
    meaning: ["불행하게도", "유감스럽게도"]
  }, {
    id: 33,
    word: "marine",
    meaning: ["바다의", "해양의"]
  }, {
    id: 34,
    word: "packaging container",
    meaning: ["포장용 용기", "포장 용기"]
  }, {
    id: 35,
    word: "agricultural",
    meaning: ["농지", "농산물"]
  }, {
    id: 36,
    word: "husk",
    meaning: ["겉껍질"]
  }, {
    id: 37,
    word: "wheat",
    meaning: ["밀"]
  }, {
    id: 38,
    word: "mycelium",
    meaning: ["균사체"]
  }, {
    id: 39,
    word: "in harmony with",
    meaning: ["~와 조화하여", "~와 협조하여", "~와 조화를 이루어"]
  }, {
    id: 40,
    word: "per capita",
    meaning: ["1인당"]
  }, {
    id: 41,
    word: "take up",
    meaning: ["계속하다", "차지하다"]
  }, {
    id: 42,
    word: "come up with",
    meaning: ["~를 생산하다", "~를 제안하다", "~를 제시하다"]
  }, {
    id: 43,
    word: "gel",
    meaning: ["젤", "겔"]
  }, {
    id: 44,
    word: "clay",
    meaning: ["점토", "찰흙"]
  }, {
    id: 45,
    word: "refillable",
    meaning: ["다시 채울 수 있는", "리필 가능한", "리필이 되는"]
  }, {
    id: 46,
    word: "journey",
    meaning: ["여행", "여정"]
  }, {
    id: 47,
    word: "experiment",
    meaning: ["실험"]
  }, {
    id: 48,
    word: "ingredient",
    meaning: ["재료", "성분", "구성 요소"]
  }, {
    id: 49,
    word: "grain",
    meaning: ["곡물", "낟알"]
  }, {
    id: 50,
    word: "growth",
    meaning: ["성장", "증가"]
  }, {
    id: 51,
    word: "guarantee",
    meaning: ["굳은 약속", "확약", "보장하다", "품질 보증을 하다"]
  }, {
    id: 52,
    word: "descendant",
    meaning: ["자손", "후예", "후손"]
  }, {
    id: 53,
    word: "climate",
    meaning: ["기후"]
  }, {
    id: 54,
    word: "feather",
    meaning: ["털"]
  }, {
    id: 55,
    word: "biography",
    meaning: ["전기", "한 사람의 일생을 적은 기록"]
  }, {
    id: 56,
    word: "consumer",
    meaning: ["소비자"]
  }, {
    id: 57,
    word: "producer",
    meaning: ["생산자"]
  }, {
    id: 58,
    word: "microplastic",
    meaning: ["미세 플라스틱"]
  },
]
